import axios from 'axios';
import url from '../../utils/url';

export default {
  namespaced: true,
  state: {
    tasks: [],
    device_id: null,
    taskCount: 0,
  },
  getters: {
    tasks: state => state.tasks.tasks,
    device_id: state => state.device_id,
    tasksCount: state => state.taskCount,
  },
  actions: {
    /**
     * This action is called when the user changes the device_id in the device selector
     * @param commit
     * @param payLoad
     * @returns {Promise<void>}
     */
    async deviceIdHasChanged({ commit }, payLoad) {
      // console.log('deviceIdHasChanged', payLoad);
      const tasks = await axios.get(url`/api/v1/accounts/${payLoad.account}/devices/${payLoad.device_id}/tasks?perPage=999999&sourceRoute=detailViewTask`);
      // console.log('tasks', tasks);
      const data = {
        device_id: payLoad.device_id,
        tasks: tasks.data,
        // taskCount: tasks.data ? tasks.data.length : 0,
      };
      commit('setTasks', data);
    },
    /**
     * This action is called when the store has no tasks for the current device_id
     * @param commit
     * @param payLoad
     * @returns {Promise<void>}
     */
    async fetchNewTasks({ commit }, payLoad) {
      // console.log('fetchNewTasks', payLoad);
      const tasks = await axios.get(url`/api/v1/accounts/${payLoad.account}/devices/${payLoad.device_id}/tasks?perPage=999999&sourceRoute=detailViewTask`);
      // console.log('tasks', tasks);
      const data = {
        device_id: payLoad.device_id,
        tasks: tasks.data,
        taskCount: tasks.data ? tasks.data.length : 0,
      };

      commit('setTasks', data);
    },
  },
  mutations: {
    setTasks(state, data) {
      // console.log('setTasks', data);
      // eslint-disable-next-line no-param-reassign
      state.tasks = data.tasks;
      // eslint-disable-next-line no-param-reassign
      state.device_id = data.device_id;
      // eslint-disable-next-line no-param-reassign
      // state.taskCount = data.tasks.length;
    },
    setDeviceId(state, device_id) {
      // eslint-disable-next-line no-param-reassign
      state.device_id = device_id;
    },
    clearTasks(state) {
      // eslint-disable-next-line no-param-reassign
      state.tasks = [];
      // eslint-disable-next-line no-param-reassign
      state.device_id = null;
    },
  },
};
